module.exports = __webpack_public_path__ + "img/img19.74437a80.jpg";